import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 120px 20px 60px;
`;

const Title = styled.h1`
  text-align: center;
  font-size: 2.8rem;
  margin-bottom: 1rem;
  color: #4DC8C4;

  @media (max-width: 768px) {
    font-size: 2.5rem;
  }
`;

const Subtitle = styled.p`
  text-align: center;
  margin-bottom: 0.5rem;
  line-height: 1.6;
  word-break: keep-all;
  font-size: 1rem;

  .mobile-break {
    display: none;
  }

  @media (max-width: ${props => props.theme.breakpoints.tablet}) {
    .mobile-break {
      display: inline;
    }
  }
`;

const Notice = styled.p`
  text-align: center;
  color: #666;
  margin-bottom: 0;
  line-height: 1.6;
  word-break: keep-all;
  font-size: 1rem;

  .mobile-break {
    display: none;
  }

  @media (max-width: ${props => props.theme.breakpoints.tablet}) {
    .mobile-break {
      display: inline;
    }
  }
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 2rem;
  
  th, td {
    padding: 12px;
    text-align: left;
    border: 1px solid #ddd;
  }

  td:first-child {
    text-align: center;
  }

  th {
    background: #f5f5f5;
    text-align: center;
  }

  td:nth-child(2) {
    text-align: center;
  }

  td:last-child {
    text-align: right;
  }

  .space-maintainer {
    .mobile-break {
      display: none;
    }
  }

  @media (max-width: ${props => props.theme.breakpoints.tablet}) {
    font-size: 14px;
    
    th, td {
      padding: 8px;
    }

    td:first-child {
      font-size: 13px;
      width: 45%;
      padding-right: 4px;

      .mobile-break {
        display: inline;
      }
    }

    td:nth-child(2) {
      font-size: 13px;
      width: 25%;
      padding: 8px 2px;
    }

    td:last-child {
      font-size: 13px;
      width: 30%;
      white-space: nowrap;
      padding-left: 4px;
    }
  }
`;

const RedNotice = styled.p`
  margin-top: 12px;
  text-align: center;
  color: #e53935;
  font-size: 1rem;
  line-height: 1.6;
  word-break: keep-all;
`;

const StyledText = styled.span`
  @media (min-width: ${props => props.theme.breakpoints.tablet}) {
    display: inline;
  }
  @media (max-width: ${props => props.theme.breakpoints.tablet}) {
    display: none;
  }
`;

const MobileText = styled.span`
  display: none;
  @media (max-width: ${props => props.theme.breakpoints.tablet}) {
    display: inline;
  }
`;

const Pricing = () => {
  const formatPrice = (price) => {
    return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  return (
    <Container>
      <Title>비급여 수가표</Title>
      <Subtitle>
        <StyledText>
          서울쥬니어치과의 진료비용을 투명하게 안내해드립니다.
        </StyledText>
        <MobileText>
          서울쥬니어치과의 진료비용을<br />
          투명하게 안내해드립니다.
        </MobileText>
      </Subtitle>
      <Notice>
        <StyledText>
          건강보험이 적용되지 않는 비급여 항목의 가격표입니다.<br />
          실제 진료비용은 환자의 상태에 따라 달라질 수 있습니다.
        </StyledText>
        <MobileText>
          건강보험이 적용되지 않는<br />
          비급여 항목의 가격표입니다.<br />
          실제 진료비용은 환자의 상태에 따라<br />
          달라질 수 있습니다.
        </MobileText>
      </Notice>
      <RedNotice>
        만 12세 이하 영구치 레진은 보험 대상입니다.
      </RedNotice>

      <Table>
        <thead>
          <tr>
            <th>진료명</th>
            <th>구분</th>
            <th>수가</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>유치 구치 레진</td>
            <td>레진</td>
            <td>{formatPrice(90000)}원</td>
          </tr>
          <tr>
            <td>유치 전치 레진</td>
            <td>레진</td>
            <td>{formatPrice(90000)}원</td>
          </tr>
          <tr>
            <td>영구치 소구치 레진</td>
            <td>레진</td>
            <td>{formatPrice(110000)}원</td>
          </tr>
          <tr>
            <td>영구치 대구치 레진</td>
            <td>레진</td>
            <td>{formatPrice(120000)}원</td>
          </tr>
          <tr>
            <td>영구치 전치 레진</td>
            <td>레진</td>
            <td>{formatPrice(150000)}원</td>
          </tr>
          <tr>
            <td>영구치 전치 축조 레진</td>
            <td>레진</td>
            <td>{formatPrice(180000)}원</td>
          </tr>
          <tr>
            <td>유치 SS Crown</td>
            <td>크라운</td>
            <td>{formatPrice(120000)}원</td>
          </tr>
          <tr>
            <td>영구치 SS Crown</td>
            <td>크라운</td>
            <td>{formatPrice(180000)}원</td>
          </tr>
          <tr>
            <td>유전치 지르코니아 Crown</td>
            <td>크라운</td>
            <td>{formatPrice(200000)}원</td>
          </tr>
          <tr>
            <td>Band &amp; Loop</td>
            <td>장치</td>
            <td>{formatPrice(200000)}원</td>
          </tr>
          <tr>
            <td>Lingual arch/ Nance holding arch<br />(악당)</td>
            <td>장치</td>
            <td>{formatPrice(300000)}원</td>
          </tr>
          <tr>
            <td>Halterman app.<br />(편측당)</td>
            <td>장치</td>
            <td>{formatPrice(600000)}원</td>
          </tr>
          <tr>
            <td className="space-maintainer">
              유치 전치 공간유지장치<br />(기본 치아 1~2개, 치아 추가 시 50,000원씩)
            </td>
            <td>장치</td>
            <td>{formatPrice(300000)}원</td>
          </tr>
          <tr>
            <td className="prevention">치면세마 / 스케일링</td>
            <td>예방치료</td>
            <td>{formatPrice(30000)}원</td>
          </tr>
          <tr>
            <td className="prevention">불소도포</td>
            <td>예방치료</td>
            <td>{formatPrice(30000)}원</td>
          </tr>
          <tr>
            <td>치료확인서</td>
            <td>서류</td>
            <td>{formatPrice(3000)}원</td>
          </tr>
          <tr>
            <td>진단서 / 소견서</td>
            <td>서류</td>
            <td>{formatPrice(10000)}원</td>
          </tr>
          <tr>
            <td>향후 치료비 추정서</td>
            <td>서류</td>
            <td>{formatPrice(30000)}원</td>
          </tr>
          <tr>
            <td>상해진단서</td>
            <td>서류</td>
            <td>{formatPrice(50000)}원</td>
          </tr>
        </tbody>
      </Table>
    </Container>
  );
};

export default Pricing; 